import { Component } from '@angular/core';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { iframeResizer } from 'iframe-resizer';

export interface EmbedBlock extends ContentBlock {
    html_embed: string;
}

@Component({
    template: `<div class="embed html-embed" [innerHTML]="block.html_embed | trustHtml"></div>`
})
export class ViewComponent extends ContentBlockViewComponent<EmbedBlock> {
    ngAfterViewInit() {
        setTimeout(() => {
            iframeResizer({ log: true }, 'iframe');
        }, 500);
    }
}

@Component({
    template: `
        <mat-form-field appearance="outline">
            <mat-label>HTML</mat-label>
            <textarea name="html" matInput cdkTextareaAutosize cdkAutosizeMinRows="5"
                    [(ngModel)]="block.html_embed" placeholder="&lt;iframe&gt;..."
                    [disabled]="locked"></textarea>

        </mat-form-field>
    `,
    styles: [
        `
        mat-form-field {
            width: 100%;
        }
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<EmbedBlock> {
}

export const EMBED_BLOCK_TYPE: ContentBlockType<EmbedBlock> = {
    id: 'embed',
    label: 'Embed (HTML)',
    icon: 'code',
    template: {
        html_embed: ''
    },
    preview: {
        html_embed: `
            The <em>quick</em> <strong>brown</strong> fox jumps
            <a href="https://google.com" target="_blank">over</a> the
            <strikethrough>lazy</strikethrough> dog
        `
    },
    previewSettings: {
        horizontalAlign: 'center',
        verticalAlign: 'center'
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
